module.exports = __webpack_public_path__ + "7bda06d4e20017c392e81bfd83b76b74.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/partnerlogos/ucsf-tobacco-logo.png
// module id = 1992
// module chunks = 0